import { NavLink } from "react-router-dom";
import { cn } from "@/lib/cn";
import { navItems } from "./navItems";
import styles from "./MobileNav.module.css";

const PRIMARY = navItems.slice(0, 2); // Dashboard, Lançamentos
const AFTER_FAB = navItems.slice(2); // Calendário, Metas & Orçamento

export function MobileNav({ onQuickAdd }: { onQuickAdd: () => void }) {
  const renderLink = ({ to, label, icon: Icon }: (typeof navItems)[number]) => (
    <NavLink
      key={to}
      to={to}
      end={to === "/"}
      className={({ isActive }) => cn(styles.link, isActive && styles.linkActive)}
    >
      <span className={styles.iconWrap}>
        <Icon size={21} strokeWidth={2.2} />
      </span>
      <span className={styles.label}>{label.split(" ")[0]}</span>
    </NavLink>
  );

  return (
    <nav className={styles.nav}>
      <div className={styles.group}>{PRIMARY.map(renderLink)}</div>
      <div className={styles.fabSlot}>
        <button className={styles.fab} onClick={onQuickAdd} aria-label="Novo lançamento">
          <span className={styles.fabPlus}>+</span>
        </button>
      </div>
      <div className={styles.group}>{AFTER_FAB.map(renderLink)}</div>
    </nav>
  );
}
